import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";

const FAQOnPremiseSection = () => {
  return <FAQSectionI18n translationPrefix="onPremisePage" itemClass="border border-border rounded-xl px-6 data-[state=open]:bg-muted/30" />;
};

export default FAQOnPremiseSection;
